module.exports = __webpack_public_path__ + "media/images/profile-c150952c7e2ec2cf298980d55b2bcde3.svg";